import React from "react";
import "rc-switch/assets/index.css";

import logger from "../../../utils/LoggerFrontend";
import ReactTooltip from "react-tooltip";

import {
  DeleteButton,
  CheckboxArea,
  AnswerWrapper,
  AnswerEditing,
  AnswerEditingError
} from "./Campaign__Create_ATS.styled";

import Checkbox from "../../../Components/Checkbox.jsx";
import { withTranslation } from "react-i18next";

class ATSSingleAnswer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
      answerInput: props?.answer?.text || ""
    };
    this.answerBox = React.createRef();
  }

  componentDidMount() {
    if (this.props.isNewAnswer && this.answerBox && this.answerBox.current) {
      this.answerBox.current.focus();
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps?.answer?.text != this.props?.answer?.text) {
      this.setState({
        answerInput: this.props?.answer?.text
      });
    }
  }
  onKeyDown(e) {
    var el = e.target;
    const { which } = e;
    logger.debug("ATSSingleAnswer:onKeyDown", "called", { target: el, which });

    if ([27, 13].includes(which)) {
      logger.debug("ATSSingleAnswer:onKeyDown", "enter pressed", { el });
      el.blur();
      return;
    }

    setTimeout(function () {
      el.style.cssText = "height:auto";
      el.style.cssText = "-moz-box-sizing:content-box";
      el.style.cssText = "height:" + el.scrollHeight + "px";
    }, 0);
  }

  onFocus(e) {
    const el = e.target;

    if (el.setSelectionRange) {
      // Double the length because Opera is inconsistent about whether a
      // carriage return is one character or two.
      var len = el.value.length * 2;
      // Timeout seems to be required for Blink
      setTimeout(function () {
        el.setSelectionRange(len, len);
      }, 0);
    } else {
      // As a fallback, replace the contents with itself
      // Doesn't work in Chrome, but Chrome supports setSelectionRange
      // eslint-disable-next-line no-self-assign
      el.value = el.value;
    }
  }

  onChangeDisqualifying() {
    const { answer, answerIndex } = this.props;
    answer.isDisqualifying = !answer.isDisqualifying;
    this.props.onEditAnswer(answerIndex, answer);
  }

  render() {
    const { answer, answerIndex, showCheckBox, hasSingleAnswer, t } = this.props;
    const { answerInput } = this.state;
    const style = {};
    const { isDisqualifying } = answer;

    if (isDisqualifying) {
      style.visibility = "visible";
      style.opacity = 1;
    }

    logger.log("Answer:CampaignCreateATS:render", "called", {
      questionIndex: this.props.questionIndex,
      answer
    });

    return (
      <AnswerWrapper>
        <AnswerEditing
          ref={this.answerBox}
          value={answerInput}
          onKeyDown={this.onKeyDown.bind(this)}
          onChange={(e) => {
            this.setState({ answerInput: e.target.value });
          }}
          onFocus={this.onFocus.bind(this)}
          onBlur={(e) => {
            if (e.target.value.length < 1) {
              return this.props.onDeleteAnswerClicked(answerIndex);
            }
            const answerObject = { ...answer, text: this.state.answerInput };
            this.props.onEditAnswer(answerIndex, answerObject);
          }}
          placeholder={t("Answer")}
          cols={100}
          rows={2}
        />
        {showCheckBox && (
          <CheckboxArea style={style}>
            <Checkbox
              checked={isDisqualifying}
              onClick={this.onChangeDisqualifying.bind(this)}
              text={t("Disqualifying")}
              reversed={true}
              activeColor="#5F5C70"
              data-tip={t(
                "Applicants with disqualifying answers will receive an automatic rejection after 10 minutes"
              )}
            />
          </CheckboxArea>
        )}
        <DeleteButton
          onClick={() => this.props.onDeleteAnswerClicked(answerIndex)}
          src="/images/delete-icon.svg"
        />
        {hasSingleAnswer && (
          <AnswerEditingError>
            {t("*Give your applicants at least two answers to decide.")}
          </AnswerEditingError>
        )}
        <ReactTooltip />
      </AnswerWrapper>
    );
  }
}

export default withTranslation()(ATSSingleAnswer);
